
<div :class="jel_getClassObject(content)">
  <p>TODO: CarteListeProduitCED</p>
</div>
